(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["houselife-b2b-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',e=>{const t=e.target.closest('.hl-b2b-product__thumb');if(!t)return;const g=t.closest('[data-b2b-gallery]'),i=g&&g.querySelector('.hl-b2b-product__main-media img');if(!i)return;i.src=t.dataset.full;i.removeAttribute('srcset');g.querySelectorAll('.hl-b2b-product__thumb').forEach(b=>b.classList.remove('is-active'));t.classList.add('is-active')});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
